'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var generated = require('../../../graphql/generated.js');
var pudoMethod = require('../../../transformers/pudoMethod.js');

const isDisabled = (selectedCategory, pudoReference, isCategoryConfirmed, multiLabelsEnabled, labelsCount) => {
  var _pudoReference$dropOf, _pudoReference$dropOf2, _pudoReference$dropOf3, _pudoReference$dropOf4, _selectedCategory$sel, _selectedCategory$sel2;
  const hasLocations = (pudoReference === null || pudoReference === void 0 ? void 0 : (_pudoReference$dropOf = pudoReference.dropOff) === null || _pudoReference$dropOf === void 0 ? void 0 : (_pudoReference$dropOf2 = _pudoReference$dropOf.sortedLocations) === null || _pudoReference$dropOf2 === void 0 ? void 0 : _pudoReference$dropOf2.locationsList) && (pudoReference === null || pudoReference === void 0 ? void 0 : (_pudoReference$dropOf3 = pudoReference.dropOff) === null || _pudoReference$dropOf3 === void 0 ? void 0 : (_pudoReference$dropOf4 = _pudoReference$dropOf3.sortedLocations) === null || _pudoReference$dropOf4 === void 0 ? void 0 : _pudoReference$dropOf4.locationsList.length) > 0;
  const hasPickup = pudoReference === null || pudoReference === void 0 ? void 0 : pudoReference.pickup;
  const noCategorySelected = !selectedCategory;
  const hasLocationsAndNoLocationSelected = hasLocations && !(selectedCategory !== null && selectedCategory !== void 0 && (_selectedCategory$sel = selectedCategory.selectedDropOff) !== null && _selectedCategory$sel !== void 0 && _selectedCategory$sel.selectedLocation) && !isCategoryConfirmed;
  const hasPickupAndNoTimeSlotSelected = hasPickup && !(selectedCategory !== null && selectedCategory !== void 0 && (_selectedCategory$sel2 = selectedCategory.selectedPickup) !== null && _selectedCategory$sel2 !== void 0 && _selectedCategory$sel2.selectedTimeSlot);
  const noLabelCount = isCategoryConfirmed && multiLabelsEnabled && !labelsCount;
  return [noCategorySelected, hasLocationsAndNoLocationSelected, hasPickupAndNoTimeSlotSelected, noLabelCount].some(Boolean);
};
const setPudoOption = async _ref => {
  let {
    client,
    isHipaaCompliant = false,
    selectedPudoOption,
    returnCart
  } = _ref;
  if (!client) throw new Error('Client not initialized');
  if (!(returnCart !== null && returnCart !== void 0 && returnCart.id) || !selectedPudoOption) throw new Error('Unable to set PUDO option: Missing required parameters');
  let mutation;
  if (isHipaaCompliant) {
    mutation = await client.mutate({
      mutation: generated.HipaaSetPudoOptionDocument,
      variables: {
        returnCartId: returnCart.id,
        pudoOption: selectedPudoOption
      }
    });
  } else {
    mutation = await client.mutate({
      mutation: generated.SetPudoOptionDocument,
      variables: {
        returnCartId: returnCart.id,
        pudoOption: selectedPudoOption
      }
    });
  }
  const {
    data
  } = mutation;
  if (!data) throw new Error('An error has occurred while setting the PUDO option');
  return data;
};

// Returns a sorted array of pudoOptions that have been augmented with a sort key.
const sortPudoOptions = (pudoOptions, sortOrder) => {
  if (!pudoOptions || !Array.isArray(sortOrder) || sortOrder.length === 0) {
    return pudoOptions;
  }
  return pudoOptions.map(option => {
    const id = pudoMethod.generatePudoId(option);
    const sort = sortOrder.indexOf(id) >= 0 ? sortOrder.indexOf(id) : 100;
    return {
      ...option,
      sort
    };
  }).sort((a, b) => a.sort - b.sort);
};

exports.isDisabled = isDisabled;
exports.setPudoOption = setPudoOption;
exports.sortPudoOptions = sortPudoOptions;
